'use strict';

const throttle = require('lodash/throttle');

const SELECTORS = {
  element: '.js-reading-bar',
  progress: '.js-reading-bar-progress',
  wrapper: '.js-reading-bar-area'
};

/**
 * Class to dynamically center an active element inside a container.
 */
class ReadingBar {
  constructor() {
    this.progressbarWrapper = $(SELECTORS.element);
    this.progressbar = $(SELECTORS.progress);
    this.area = $(SELECTORS.wrapper);
    this.init();
  }

  init() {
    if ((this.progressbarWrapper.length > 0) && (this.progressbar.length > 0) && (this.area.length > 0)) {
      const areaTop = this.area.offset().top;
      const areaHeight = this.area.innerHeight();

      $(window).on('scroll', throttle(() => {
        const scrollTop = $(window).scrollTop();
        const windowHeight = $(window).innerHeight();
        const barPercentage = (scrollTop - areaTop) / (areaHeight - windowHeight) * 100;

        this.progressbar.css('width', `${barPercentage}%`);

        if (scrollTop > areaTop) {
          this.progressbarWrapper.addClass('cc-active');
        } else {
          this.progressbarWrapper.removeClass('cc-active');
        }
      }, 100));
    }
  }
}

module.exports = () => {
  new ReadingBar();
};
